(function () {
	let swiperMulticolumn;
	let sectionResizeObserver;
	const multicolumnSwipeEnabled = document.querySelector(
		".swiper--multicolumn",
	);

	const addClasses = () => {
		const slides = document.querySelectorAll(".swiper--multicolumn .multicolumn-list__item");
		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	};

	const initSlider = () => {
		if (swiperMulticolumn || !multicolumnSwipeEnabled) return;
		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
			loop: false,
			breakpoints: {
				320: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
				},
				640: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 24,
				},
			},

			pagination: {
				el: ".multicolumn__pagination",
				type: "fraction",
			},
			navigation: {
				nextEl: ".multicolumn__button-next",
				prevEl: ".multicolumn__button-prev",
			},
		});
	};

	const destroySlider = () => {
		const slides = document.querySelectorAll(".multicolumn-list__item");

		if (Array.isArray(swiperMulticolumn)) {
			swiperMulticolumn.forEach((swiper) => {
				if (!swiper.destroyed) swiper.destroy(true, true);
			});
		} else {
			if (!swiperMulticolumn.destroyed) swiperMulticolumn.destroy(true, true);
		}
		swiperMulticolumn = null;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");

		if (!multicolumnSection || !multicolumnSwipeEnabled) return;
		sectionResizeObserver?.disconnect();
		sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991 && multicolumnSwipeEnabled) {
				if (!swiperMulticolumn) {
					addClasses();
					initSlider();
				}
			} else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	initMulticolumn();
	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
	});
})();
